export default "__VITE_ASSET__DhX4OFIn__$_?nuxt_component=async&nuxt_component_name=IconSocialsMessenger&nuxt_component_export=default__"